<template>
  <td :class="['forecast-day', isCurrentDay() ? 'current-day' : '', day.isChanged() ? 'changed' : '']">
    <span v-if="day.isBlank"></span>
    <div v-else class="main-div">
      <span>{{day.date.format('DD')}}</span>
      <div class="input-div">
        <input :disabled="!hasInput" v-model="day.value" type="text" class="forecast-day__input"><b class="close-forecast"></b>
      </div>
    </div>
  </td>
</template>

<script>
import CalendarDay from '@/components/station-create/CalendarDay'
import moment from 'moment'

export default {
  name: 'ProductionDay',
  props: {
    day: {
      required: true,
      type: CalendarDay
    }
  },
  computed: {
    hasInput () {
      return this.day.date.format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    isCurrentDay () {
      if (this.day.isBlank) {
        return false
      }
      return this.day.date.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    }
  }
}
</script>
